<template>
  <div class="popUpWrap dark">
    <section class="popup dark basic">
      <div class="topArea">
        <div class="exit" @click.stop="onClickClose"></div>
      </div>
      <div class="scrollY">
        <div class="textArea">
          <h5>{{ t('skillCertify-template-save-title') }}</h5>
          <p v-html="content" />
        </div>
        <input
            type="text"
            :class="{error: !isValidTemplateName && isModifyTemplate}"
            v-model="templateName"
            :placeholder="t('skillCertify-template-name-placeholder')"
            @keydown="isModifyTemplate = true"
        >
        <p v-if="!isValidTemplateName && isModifyTemplate" class="errorMessage">
          <span class="icon"></span>{{ t('skillCertify-error-template-name') }}
        </p>
        <div class="btnArea">
          <button type="button" class="cancel" @click.stop="onClickClose">{{ t('common-cancel') }}</button>
          <button
              type="button"
              :class="{disabled: !isValidTemplateName}"
              @click.stop="onClickSave">
            {{ t('common-save') }}
          </button>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import {useDialogStore} from '~/store/dialog/dialogStore';
import {useI18n} from 'vue-i18n';
import {useProSkillAssureService} from '~/composables/service/useProSkillAssureService';
import {
  ProSkillAssureTemplateCreateModel
} from '~~/package/mapper/proSkillAssure/model/template/ProSkillAssureTemplateCreateModel';
import {useToastStore} from '~/store/toast/toastStore';
import {ToastType} from '~/components/Common/Toast/model/ToastType';

const {t} = useI18n()
const dialogStore = useDialogStore();
const toastStore = useToastStore();
const proSkillAssureService = useProSkillAssureService();

const templateName = ref("");
const isModifyTemplate = ref(false);

const content = computed(() => {
  return t('skillCertify-template-save-info-1', { element: `<span>${t('skillCertify-template-save-info-2')}</span>`})
})

// ASMT-AUTH-07: Save as Template — 템플릿명 1–30자 실시간 검증
const isValidTemplateName = computed(() => {
  return templateName.value.length >= 1 && templateName.value.length <= 30
})

const onClickClose = () => {
  dialogStore.close();
};

const onClickSave = () => {
  if(!isValidTemplateName.value) return;

  const templateData = new ProSkillAssureTemplateCreateModel(
      templateName.value,
      dialogStore.options.props.assessmentSetList.flatMap(assessment => {
        return assessment.testTemplateList.map(template => ({
          testTemplateId: template.id,
          referenceUrlExposureFlag: assessment.referenceUrlExposureFlag
        }));
      }),
      dialogStore.options.props.timeZoneId
  );

  proSkillAssureService.addProSkillAssureTemplate(templateData).then((isSuccess: boolean) => {
    if(isSuccess){
      toastStore.openToast({
        toastType: ToastType.SUCCESS,
        contents: t('skillCertify-template-save-success'),
      });
    }
    else {
      toastStore.openToast({
        toastType: ToastType.FAILED,
        contents: t('skillCertify-template-save-fail'),
      });
    }
  }).catch(() => {
    toastStore.openToast({
      toastType: ToastType.FAILED,
      contents: t('skillCertify-template-save-fail'),
    });
  }).finally(() => {
    onClickClose();
  })
}
</script>

